import { render } from "./SaveContractTemplates.vue?vue&type=template&id=14cfec40"
import script from "./SaveContractTemplates.vue?vue&type=script&lang=js"
export * from "./SaveContractTemplates.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__